module.exports = __webpack_public_path__ + "img/Damp 6.jpg";